// src/components/TSOAuthDetector.tsx - RAPID RESPONSE VERSION
import React, { useEffect, useState } from 'react';
import { supabase } from '../lib/supabaseClient';

const TSOAuthDetector: React.FC = () => {
  const [hasChecked, setHasChecked] = useState(false);
  
  useEffect(() => {
    // Only run this once
    if (hasChecked) return;
    
    const checkTSOToken = async () => {
     
      try {
        // Skip if already authenticated
        const { data: { session } } = await supabase.auth.getSession();
        if (session?.user) {
          setHasChecked(true);
          return;
        }
        
        console.log('No existing session found');
        
        // Check URL for token parameter
        const urlParams = new URLSearchParams(window.location.search);
        const urlToken = urlParams.get('auth_token');
        
        // Check localStorage
        let tsoToken = localStorage.getItem('sb-auth-token');
        
        // If URL has token, use it
        if (urlToken) {
          tsoToken = urlToken;
          // Save to localStorage for future use
          localStorage.setItem('sb-auth-token', urlToken);
          
          // Clean up URL
          if (window.history && window.history.replaceState) {
            const cleanUrl = window.location.pathname;
            window.history.replaceState({}, document.title, cleanUrl);
          }
        }
        
        if (!tsoToken) {
          setHasChecked(true);
          return;
        }
        
        // Parse the token
        let tokenData;
        try {
          tokenData = JSON.parse(tsoToken);
           } catch (parseErr) {
          setHasChecked(true);
          return;
        }
        
        // Set session with token
        if (tokenData?.access_token) {
        
          const { data, error } = await supabase.auth.setSession({
            access_token: tokenData.access_token,
            refresh_token: tokenData.refresh_token || ''
          });
          
          if (error) {
            setHasChecked(true);
            return;
          }
            

          if ((window as any).triggerAuthRecheck) {
            setTimeout(() => {
              (window as any).triggerAuthRecheck();
            }, 200);
          } else {
          }
        } else {
        }
      } catch (err: any) {
      } finally {
        setHasChecked(true);
      }
    };

    checkTSOToken();
  }, [hasChecked]);

  // This component doesn't render anything visible
  return null;
};

export default TSOAuthDetector;